import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingSpinner = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 2,
        border: 0,
      }}
    >
      <CircularProgress sx={{ color: '#b2b2b2' }} />
    </Box>
  );
};

export default LoadingSpinner;
